import React, { useState } from 'react';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import classes from './styles.module.scss';
import AboutUsFormModal from './AboutUsFormModal';
import DeleteConfirm from '../councellingStudentContainer/features/DeleteConfirm';
import { actionNotifier } from '../../components/ui/toast';

const formatDate = (value) => {
    if (!value) {
        return '-';
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return '-';
    }

    return date.toLocaleString();
};

const SiteAboutUsContainer = ({
    aboutUsList,
    isLoading,
    onDeleteAboutUs,
    onEditAboutUs,
    onSaveAboutUs,
    onUploadFile,
    search,
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingItem, setEditingItem] = useState(null);
    const [deleteId, setDeleteId] = useState(null);

    const filteredList = aboutUsList.filter((item) => {
        if (!search.trim()) {
            return true;
        }

        const normalizedSearch = search.toLowerCase();
        return [
            item?.name,
            item?.designation,
            item?.title,
        ].some((field) => field?.toLowerCase().includes(normalizedSearch));
    });

    const handleOpenCreateModal = () => {
        setEditingItem(null);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setEditingItem(null);
        setIsModalOpen(false);
    };

    const handleEditClick = async (item) => {
        const details = await onEditAboutUs(item);
        setEditingItem(details);
        setIsModalOpen(true);
    };

    const handleDeleteClick = (id) => {
        setDeleteId(id);
    };

    const handleConfirmDelete = async () => {
        if (!deleteId) {
            return;
        }

        try {
            await onDeleteAboutUs(deleteId);
            setDeleteId(null);
        } catch (error) {
            actionNotifier.error(error?.data?.message || 'Unable to delete About Us entry.');
        }
    };

    return (
        <div className={classes.aboutus_page_container}>
            <div className={classes.page_header}>
                <div />

                <button
                    type="button"
                    className={classes.add_new_btn_main}
                    onClick={handleOpenCreateModal}
                >
                    <AddCircleOutlineIcon fontSize="small" /> Add About Us
                </button>
            </div>

            <div className={classes.aboutus_list_container}>
                {filteredList.length > 0 ? (
                    <div className={classes.table_wrapper}>
                        <table className={classes.aboutus_table}>
                            <thead>
                                <tr>
                                    <th>Serial No.</th>
                                    <th>Image</th>
                                    <th>Name</th>
                                    <th>Designation</th>
                                    <th>Created At</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredList.map((item) => (
                                    <tr key={item.id}>
                                        <td>{item.serialNumber || '-'}</td>
                                        <td>
                                            {(item.image || item.imageUrl || item.link) ? (
                                                <img
                                                    src={item.image || item.imageUrl || item.link}
                                                    alt={item.name || item.title || 'About Us'}
                                                    className={classes.table_image}
                                                />
                                            ) : (
                                                <span className={classes.no_image}>No image</span>
                                            )}
                                        </td>
                                        <td className={classes.name_cell}>{item.name || item.title || '-'}</td>
                                        <td>{item.designation || '-'}</td>
                                        <td>{formatDate(item.createdAt)}</td>
                                        <td>
                                            <div className={classes.action_buttons}>
                                                <button
                                                    type="button"
                                                    className={classes.edit_btn}
                                                    onClick={() => handleEditClick(item)}
                                                >
                                                    <EditOutlinedIcon fontSize="small" /> Edit
                                                </button>
                                                <button
                                                    type="button"
                                                    className={classes.delete_btn}
                                                    onClick={() => handleDeleteClick(item.id)}
                                                >
                                                    <DeleteOutlineIcon fontSize="small" /> Delete
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div className={classes.empty_state}>
                        No About Us records found.
                    </div>
                )}
            </div>

            <AboutUsFormModal
                open={isModalOpen}
                handleClose={handleCloseModal}
                handleSave={onSaveAboutUs}
                onUploadFile={onUploadFile}
                initialData={editingItem}
                isLoading={isLoading}
            />

            {deleteId !== null ? (
                <DeleteConfirm
                    isModalOpen={true}
                    handleModal={handleConfirmDelete}
                    setIsModalOpen={() => setDeleteId(null)}
                    title="About Us"
                />
            ) : null}
        </div>
    );
};

export default SiteAboutUsContainer;
